import React, { useMemo } from 'react'
import { Html } from '@react-three/drei'
import type { Vector3 } from 'three'
import * as THREE from 'three'
import styles from './description-label.module.scss'

type Props = {
  description: string
  position: Vector3 | [number, number, number]
  color: string
  useDepthTest?: boolean
}

export const DescriptionLabel = React.memo(
  ({ description, position, color, useDepthTest = true }: Props) => {
    const pos = Array.isArray(position) ? new THREE.Vector3(...position) : position

    const offsetPosition = useMemo<[number, number, number]>(() => {
      const absX = Math.abs(pos.x)
      const absZ = Math.abs(pos.z)

      let xOffset = 0
      let zOffset = 0

      if (absX > absZ) {
        xOffset = pos.x > 0 ? 0.8 : -0.8
      } else {
        zOffset = pos.z >= 0 ? 0.8 : -0.8
      }

      return [pos.x + xOffset, pos.y + 0.3, pos.z + zOffset]
    }, [pos])

    if (!description) return null

    return (
      <Html
        position={offsetPosition}
        center
        occlude={useDepthTest}
        className={styles.label}>
        <div className={styles.content} style={{ borderColor: color }}>
          {description}
        </div>
      </Html>
    )
  },
)
